const homesectionapi = [
    {
        id : "1",
        heading : "welcome to",
        subheading: "Internet Business Hub",
        info: "Innovative Web Solutions & Brand Growth.",
    }
]

export default homesectionapi